import { base64URLEncode } from '../utils/string';
/**
 * Characters allowed in the code verifier and code challenge
 */
const ALLOWED_CHARACTERS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-._~';
export const generateCodeVerifier = (length = 128) => {
    let verifier = '';
    const randomArray = new Uint8Array(length);
    crypto.getRandomValues(randomArray);
    randomArray.forEach(byte => {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        verifier += ALLOWED_CHARACTERS[byte % ALLOWED_CHARACTERS.length];
    });
    return verifier;
};
export const generateCodeChallenge = async (codeVerifier) => {
    const data = new TextEncoder().encode(codeVerifier);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return base64URLEncode(String.fromCharCode(...new Uint8Array(hash)));
};
